const validateNewsForm = form => {
  const isGermanValid = form.germanTitle.length <= 500 && form.germanText.length <= 1500;
  const isFrenchValid = form.frenchTitle.length <= 500 && form.frenchText.length <= 1500;
  const isItalianValid = form.italianTitle.length <= 500 && form.italianText.length <= 1500;
  const isEnglishValid = form.englishTitle.length <= 500 && form.englishText.length <= 1500;
  return isGermanValid && isFrenchValid && isItalianValid && isEnglishValid;
};

export default validateNewsForm;
